import { useQuery } from '@tanstack/react-query';
import { getFunnelInboxContacts } from 'API/linkedin-funnel';
import { AxiosError } from 'axios';
import { useUserData } from 'hooks/use-user-data';
import { useEffect } from 'react';
import useErrorStore, { CustomErrorClass } from 'stores/error-store';
import { InboxContact } from './funnel-inbox.types';

const FETCH_INTERVAL = 15 * 60 * 1000;

export const useInboxContacts = (campaignId: string | false) => {
  const { token } = useUserData();

  const handleOpenErrorDialog = useErrorStore((state) => state.handleOpenErrorDialog);

  const { data, isLoading, isError, error } = useQuery<InboxContact[]>({
    queryKey: ['inboxContacts', token, campaignId],
    queryFn: ({ signal }) => getFunnelInboxContacts(campaignId as string, signal),
    enabled: !!campaignId,
    refetchInterval: FETCH_INTERVAL,
  });

  useEffect(() => {
    if (isError) {
      const customError = new CustomErrorClass(error as AxiosError);
      handleOpenErrorDialog(customError, customError.request, customError.requestType);
    }
  }, [isError, error]);

  return {
    contacts: Array.isArray(data) ? data : [],
    isLoading,
  };
};
